module.exports = __webpack_public_path__ + "static/media/normal2.6e4834f5.svg";